import { render, staticRenderFns } from "./AgentGridClaimStage.vue?vue&type=template&id=4d152e40&scoped=true&"
import script from "./AgentGridClaimStage.vue?vue&type=script&lang=js&"
export * from "./AgentGridClaimStage.vue?vue&type=script&lang=js&"
import style0 from "./AgentGridClaimStage.vue?vue&type=style&index=0&id=4d152e40&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4d152e40",
  null
  
)

export default component.exports